// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d197ddea","239":"ca1d2094","455":"256f9e1f"}[chunkId] + ".chunk.js";
};